import React from 'react';
import styled from 'styled-components';
import { CDN_ASSET_URL } from '../../services/AssetsService';
import { fptLogoHorizontal, iconPartner } from '../../assets/Images';


const Panel = styled.div`
  flex: initial;
  display: flex;
  flex-direction: column;
  padding: 0;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  margin: 0 0 32px;

  & img {
    text-align: center;
  }
`;

const ShopLogo = styled.img.attrs((props) => ({
  src: props.theme.shopLogo,
}))`
  display: block;
  width: auto;
  max-height: 9vh;
  min-height: 25px;
  max-width: 100%;
`;

const FPTLogo = styled.img`
  display: block;
  width: auto;
  max-height: 3vh;
  min-height: 25px;
`;

const AND = styled.img`
  display: ${(props) => (props.theme.shopLogo ? 'block' : 'none')};
  width: auto;
  height: 3vh;
  opacity: 1;
`;

const LogoPanel = function () {
  return (
    <Panel>
      <ShopLogo />
      <AND src={iconPartner} />
      <FPTLogo src={fptLogoHorizontal} />
    </Panel>
  )
}

export default LogoPanel
